var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#020203",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.55 12.5h9.9"
  })));
};
export default SvgMinus;